import { Component, Mixins } from 'vue-property-decorator'
import { email, maxLength, minLength, required } from 'vuelidate/lib/validators'

import { Validation, validationMixin } from 'vuelidate'

import { CardsService, BankAndTypeCard, ApiError } from '@/api'
import { mock } from '@/tools'
import { ClaimForm } from '@/models'

@Component<ConnectCardValidations>({
  validations: {
    form: {
      mainData: {
        middleName: {
          maxLength: maxLength(60),
        },
        lastName: {
          maxLength: maxLength(60),
          required,
        },
        firstName: {
          maxLength: maxLength(60),
          required,
        },
        gender: { required },
        snils: { required, maxLength: maxLength(14) },
        birthPlace: { maxLength: maxLength(700), required },
      },
      contacts: {
        regAddress: { maxLength: maxLength(150), required },
        factAddress: { maxLength: maxLength(150) },
        temporaryRegAddress: { maxLength: maxLength(150) },
        email: { email, required, maxLength: maxLength(50) },
        mobilePhone: { minLength: minLength(16), required },
        phone: { minLength: minLength(16) },
      },
      cardInfo: {
        cardNumber: {
          minLength: minLength(19),
          maxLength: maxLength(23),
          required,
          async isValid(value: string) {
            if (this.form.isEdit) return true
            if (!value) return false
            if (value.length > 8) {
              try {
                this.cardInfo = await CardsService.checkCardNumber(value.replaceAll(' ', ''))
                return true
              } catch (error) {
                mock(error)
                this.cardInfo = null
                if (error instanceof ApiError) {
                  this.cardNumberError = error.body.description
                } else {
                  this.cardNumberError = 'Не удалось проверить номер карты'
                }
                return false
              }
            }
            return false
          },
        },
        dateTo: { required },
      },
    },
  },
})
export class ConnectCardValidations extends Mixins<Validation>(validationMixin) {
  cardInfo: BankAndTypeCard = null
  cardNumberError: string = null
  form!: ClaimForm

  get cardErrors() {
    if (!this.$v.form.cardInfo.cardNumber.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.cardInfo.cardNumber.$anyError)
      if (this.cardNumberError) errors.push(this.cardNumberError)
      else errors.push('Номер карты должен содержать от 16 до 19 цифр')
    return errors
  }

  get cardDateToErrors() {
    if (!this.$v.form.cardInfo.dateTo.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.cardInfo.dateTo.$anyError) errors.push('Поле обязательно для заполнения')
    return errors
  }

  get birthPlaceErrors() {
    if (!this.$v.form.mainData.birthPlace.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.mainData.birthPlace.$anyError) errors.push('Поле обязательно для заполнения')
    return errors
  }

  get temporaryAddrErrors() {
    if (!this.$v.form.contacts.temporaryRegAddress?.$dirty) return []

    const errors: Array<string> = []
    if (!this.$v.form.contacts.temporaryRegAddress?.maxLength) errors.push('Поле может содержать до 150 символов')
    if (this.$v.form.contacts.temporaryRegAddress?.$anyError) errors.push('Поле обязательно для заполнения')
    return errors
  }

  get factAddrErrors() {
    if (!this.$v.form.contacts.factAddress?.$dirty) return []

    const errors: Array<string> = []
    if (!this.$v.form.contacts.factAddress?.maxLength) errors.push('Поле может содержать до 150 символов')
    if (this.$v.form.contacts.factAddress?.$anyError) errors.push('Поле обязательно для заполнения')
    return errors
  }

  get regAddrErrors() {
    if (!this.$v.form.contacts.regAddress?.$dirty) return []

    const errors: Array<string> = []
    if (!this.$v.form.contacts.regAddress?.maxLength) errors.push('Поле может содержать до 150 символов')
    if (this.$v.form.contacts.regAddress?.$anyError) errors.push('Поле обязательно для заполнения')
    return errors
  }

  get snilsErrors() {
    if (!this.$v.form.mainData.snils?.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.mainData.snils.$anyError) errors.push('Поле обязательно для заполнения')
    return errors
  }

  get mobilePhoneErrors() {
    if (!this.$v.form.contacts.mobilePhone?.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.contacts.mobilePhone?.$anyError) errors.push('Перепроверьте номер')
    return errors
  }

  get phoneErrors() {
    if (!this.$v.form.contacts.phone?.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.contacts.phone?.$anyError) errors.push('Перепроверьте номер')
    return errors
  }

  get mailErrors() {
    if (!this.$v.form.contacts.email?.$dirty) return []

    const errors: Array<string> = []
    if (!this.$v.form.contacts.email.email) errors.push('Неправильный формат почты')
    if (!this.$v.form.contacts.email.maxLength) errors.push('Почта должна содержать до 50 символов')
    return errors
  }

  get lastNameErrors() {
    if (!this.$v.form.mainData.lastName?.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.mainData.lastName?.$anyError) errors.push('Некорректно заполнена Фамилия')
    return errors
  }

  get firstNameErrors() {
    if (!this.$v.form.mainData.firstName?.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.mainData.firstName?.$anyError) errors.push('Некорректно заполнено Имя')
    return errors
  }

  get middleNameErrors() {
    if (!this.$v.form.mainData.middleName?.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.mainData.middleName?.$anyError) errors.push('Некорректно заполнено Отчество')
    return errors
  }

  get genderErrors() {
    if (!this.$v.form.mainData.gender?.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.mainData.gender?.$anyError) errors.push('Необходимо выбрать пол')
    return errors
  }

  get birthDateErrors() {
    if (!this.$v.form.contacts.factAddress?.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.contacts.factAddress.$anyError) errors.push('Необходимо указать дату рождения')
    return errors
  }
}
